import { createUseStyles } from "react-jss";
import { ITheme } from "../../types/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    top: 0,
    insetInlineStart: 0,
    width: "100%",
    position: "fixed",
    display: "flex",
    alignItems: "center",
    background: theme.colors.background4,
    "&.s-success": {
      background: theme.colors.confirm,
    },
    "&.s-warning": {
      background: theme.colors.warning,
    },
    "&.s-error": {
      background: theme.colors.error,
    },
    padding: theme.spacing.space16,
    zIndex: theme.zIndex.dialog + 3,
  },
  icon: {
    height: 28,
  },
  message: {
    width: "100%",
    textAlign: "center",
    marginInlineStart: 5,
  },
}));
